<template>
  <div>
    <v-sheet class="review-sheet">
      <template v-if="isMobile">
        <div class="mobile-reviews">
          <v-card
            v-for="review in shuffledReviews"
            :key="review.fullName"
            class="review-card"
            :class="{ 'elevation-10': review.isSelected }"
            @click="review.isSelected = !review.isSelected"
          >
            <v-card-title>
              <div class="flex justify-between items-start w-full">
                <div class="flex-1">
                  <div class="rating-wrapper mobile-rating" style="justify-content: flex-start">
                    <v-rating
                      :model-value="review.stars"
                      length="10"
                      readonly
                      density="compact"
                      color="#f3d129"
                      size="small"
                      :item-labels="['' + review.stars + '/10', '', '', '', '', '', '', '', '', '']"
                    />
                  </div>
                </div>
                <v-btn icon class="clean-icon">
                  <v-icon v-if="review.isSelected">mdi-chevron-up</v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
              </div>
              <div class="w-full mt-1">
                {{ review.fullName }} - {{ review.country || "Country TBD" }}
                <span class="fi" :class="'fi-' + getCountryCode(review.country)"></span>
              </div>
            </v-card-title>
            <v-card-subtitle class="text-white/70">
              Referring to:
              <p style="text-decoration: underline">{{ review.service }}</p>
            </v-card-subtitle>
            <v-card-text class="text-white">"{{ review.commentTitle }}"</v-card-text>
            <v-card-text v-if="review.isSelected" class="text-white" style="white-space: pre-wrap; word-wrap: break-word">
              <p><strong>Name:</strong> <u>{{ review.fullName }}</u></p>
              <p><strong>Company:</strong> <u>{{ review.companyName }}</u></p>
              <p><strong>Industry:</strong> <u>{{ review.industry }}</u></p>
              <p><strong>More Information:</strong> {{ review.comment }}</p>
            </v-card-text>
          </v-card>
        </div>
      </template>
      <template v-else>
        <v-slide-group v-model="model" class="pa-4" selected-class="bg-primary" show-arrows>
          <v-slide-group-item
            v-for="review in shuffledReviews"
            :key="review.fullName"
            v-slot="{ isSelected, toggle, selectedClass }"
          >
            <v-card
              :class="['review-card', 'ma-4', selectedClass, { 'elevation-10': isSelected }]"
              @click="toggle"
              style="max-width: 500px"
            >
              <v-card-title>
                <div class="flex justify-between items-start w-full">
                  <div class="flex-1">
                    <div style="justify-content: flex-start">
                      <v-rating
                        :model-value="review.stars"
                        length="10"
                        readonly
                        dense
                        color="#f3d129"
                        size="medium"
                        :item-labels="['' + review.stars + '/10', '', '', '', '', '', '', '', '', '']"
                      />
                    </div>
                  </div>
                  <v-btn icon class="clean-icon">
                    <v-icon v-if="isSelected">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </v-btn>
                </div>
                <div class="w-full mt-1">
                  {{ review.fullName }} - {{ review.country || "Country TBD" }}
                  <span class="fi" :class="'fi-' + getCountryCode(review.country)"></span>
                </div>
              </v-card-title>
              <v-card-subtitle class="text-white/70">
                Referring to:
                <p style="text-decoration: underline">{{ review.service }}</p>
              </v-card-subtitle>
              <v-card-text class="text-white">"{{ review.commentTitle }}"</v-card-text>
              <v-card-text v-if="isSelected" class="text-white" style="white-space: pre-wrap; word-wrap: break-word">
                <p><strong>Name:</strong> <u>{{ review.fullName }}</u></p>
                <p><strong>Company:</strong> <u>{{ review.companyName }}</u></p>
                <p><strong>Industry:</strong> <u>{{ review.industry }}</u></p>
                <p><strong>More Information:</strong> {{ review.comment }}</p>
              </v-card-text>
            </v-card>
          </v-slide-group-item>
        </v-slide-group>
      </template>
    </v-sheet>
  </div>
</template>

<script>
import { ref, computed } from "vue";

export default {
  name: "CustomerReviews",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const customerReviews = ref([
      {
        stars: 8,
        service: "CTO as a Service",
        commentTitle: "Helpful service, helps us transition do in house CTO.",
        fullName: "Michael Johnson",
        country: "United States",
        companyName: "SSL Inc.",
        industry: "E-commerce",
        comment: "The service provided a good foundation for our tech strategy, but as we scaled, the need for a more dedicated presence became apparent.",
      },
      {
        stars: 10,
        service: "CTO as a Service",
        commentTitle: "Good insights, we work side by side.",
        fullName: "David Smith",
        country: "United States",
        companyName: "Robinson Apparel",
        industry: "E-commerce",
        comment: "We appreciated the strategic insights offered, we appreciate the fact that they take part on meetings from other areas to deeply understand what we need and build accordingly to that.",
      },
      {
        stars: 8,
        service: "CTO as a Service",
        commentTitle: "Service was competent but we outgrew the part-time arrangement and hired a full-time CTO.",
        fullName: "Christopher Brown",
        country: "United States",
        companyName: "Nails and nails inc.",
        industry: "E-commerce",
        comment: "The part-time consultancy was effective initially, providing competent tech leadership that helped shape our early decisions. Nonetheless, our expanding needs eventually highlighted the constraints of not having a full-time CTO.",
      },
      {
        stars: 9,
        service: "CTO as a Service",
        commentTitle: "They became a crucial part of our team.",
        fullName: "Jessica Miller",
        country: "United States",
        companyName: "APL",
        industry: "E-commerce",
        comment: "The advice we received was useful and positively influenced our technology path.",
      },
      {
        stars: 10,
        service: "CTO as a Service",
        commentTitle: "Useful, but our expanding operation necessitated a full-time CTO.",
        fullName: "Sarah Wilson",
        country: "United States",
        companyName: "Jones LLC",
        industry: "Construction",
        comment: "Initially, the external CTO service was quite effective, setting up a strong technical foundation. However, as our business expanded, the arrangement felt somewhat restrictive, pushing us to seek a full-time internal solution.",
      },
      {
        stars: 10,
        service: "CTO as a Service",
        commentTitle: "Very effective, reliable team, we can count on them",
        fullName: "James Moore",
        country: "United States",
        companyName: "Bright Builders",
        industry: "Construction",
        comment: "Honestly this is exactly what we needed.",
      },
      {
        stars: 10,
        service: "CTO as a Service",
        commentTitle: "Provided valuable service, a real CTO, able to manage resources and prioritize.",
        fullName: "Robert Taylor",
        country: "United States",
        companyName: "Fut Vis",
        industry: "Small Retail",
        comment: "We take comfort in having them overseeing the operation and helping every area build tools that help in efficiency.",
      },
      {
        stars: 10,
        service: "Custom Development",
        commentTitle: "Creative and solution-oriented, effectively handled our complex technical needs.",
        fullName: "Juan Carlos Ruiz",
        country: "Mexico",
        companyName: "Accesorios DDN",
        industry: "E-commerce",
        comment: "The team managed to deliver creative solutions that were crucial for our project's success. While the engagement was mostly positive, as we expanded, the need for a full-time technical lead began to show.",
      },
      {
        stars: 9,
        service: "Custom Development",
        commentTitle: "Problem solvers who helped us navigate tricky development hurdles with ease.",
        fullName: "Diego Martinez",
        country: "Mexico",
        companyName: "PyN Accesorios",
        industry: "Small Retail",
        comment: "Their ability to address complex technical challenges was impressive and pivotal for our project. The service was extremely beneficial, though as we grew, the occasional need for more consistent in-person interactions was felt.",
      },
      {
        stars: 10,
        service: "Custom Development",
        commentTitle: "Their innovative approaches helped overcome technical challenges in our projects.",
        fullName: "Ivan Dimitrov",
        country: "Bulgaria",
        companyName: "Ivan Dimitrov",
        industry: "Lawyer Firm",
        comment: "The innovative strategies employed were key in navigating our technical landscape. While the service was predominantly positive, the growing demands of our projects eventually called for a more permanent technical leader, so we extended their contract indefinitely",
      },
      {
        stars: 9,
        service: "Custom Development",
        commentTitle: "Their innovative approaches helped overcome technical challenges in our projects.",
        fullName: "Juan Palazuelo",
        country: "Chile",
        companyName: "Not Fashion",
        industry: "E-commerce",
        comment: "The innovative strategies employed were key in navigating our technical landscape. While the service was predominantly positive, the growing demands of our projects eventually called for a more permanent technical leader.",
      },
      {
        stars: 9,
        service: "CTO as a Service",
        commentTitle: "Exceptional service that perfectly matched our growth trajectory.",
        fullName: "Felipe González",
        country: "Chile",
        companyName: "Guerra y Guerra SA",
        industry: "Construction",
        comment: "The CTO as a Service was instrumental in aligning our technology with our business goals. As we scaled, the service seamlessly adapted to our needs, providing exceptional value and expertise.",
      },
      {
        stars: 8,
        service: "CTO as a Service",
        commentTitle: "Outstanding strategic leadership that drove our success.",
        fullName: "Laura Fernández",
        country: "Chile",
        companyName: "InnovativeTech Ltda.",
        industry: "Small Retail",
        comment: "Their strategic leadership was pivotal in our growth phase, offering insights that drove our success. The flexibility and expertise provided were beyond our expectations, making the service highly valuable.",
      },
      {
        stars: 10,
        service: "CTO as a Service",
        commentTitle: "A game-changer for our technological advancements.",
        fullName: "Carlos Rojas",
        country: "Chile",
        companyName: "JN y asociados",
        industry: "Lawyer Firm",
        comment: "The service was a game-changer for us, driving significant technological advancements. The expert guidance and seamless integration with our team ensured we stayed ahead in our industry.",
      },
      {
        stars: 10,
        service: "CTO as a Service",
        commentTitle: "Transformed our tech strategy with exceptional results.",
        fullName: "María Valdés",
        country: "Chile",
        companyName: "Insumos de Belleza Valdes SpA",
        industry: "E-commerce",
        comment: "Their expertise transformed our tech strategy, resulting in exceptional outcomes. The service was highly effective in meeting our evolving needs, making a significant impact on our business.",
      },
      {
        stars: 9,
        service: "Custom Development",
        commentTitle: "Innovative solutions that met our complex development needs.",
        fullName: "Janne Virtanen",
        country: "Finland",
        companyName: "New Solutions Oy",
        industry: "E-commerce",
        comment: "The custom development services provided were highly innovative and met our complex technical needs. While the overall experience was positive, we occasionally felt the need for more frequent updates.",
      },
      {
        stars: 8,
        service: "CTO as a Service",
        commentTitle: "Outstanding service that significantly boosted our growth.",
        fullName: "Anna Mäkinen",
        country: "Finland",
        companyName: "KimPoint Oy",
        industry: "Construction",
        comment: "The CTO as a Service was outstanding, significantly boosting our growth. Their expertise and strategic insights were invaluable, seamlessly integrating with our team and driving us forward.",
      },
      {
        stars: 9,
        service: "CTO as a Service",
        commentTitle: "Exceptional leadership that guided our tech strategy.",
        fullName: "Mikko Nieminen",
        country: "Finland",
        companyName: "Innovatech Oy",
        industry: "Small Retail",
        comment: "Their leadership was exceptional, guiding our tech strategy with precision. The service provided invaluable insights and was highly adaptable to our evolving needs, making a significant impact on our success.",
      },
      {
        stars: 9,
        service: "CTO as a Service",
        commentTitle: "Excellent strategic guidance that enhanced our tech capabilities.",
        fullName: "Carlos López",
        country: "Colombia",
        companyName: "Tecnologías Avanzadas SAS",
        industry: "Lawyer Firm",
        comment: "The strategic guidance provided was excellent, significantly enhancing our tech capabilities. Their expertise and seamless integration with our team were invaluable, driving our growth and success.",
      },
      {
        stars: 9,
        service: "CTO as a Service",
        commentTitle: "Top-notch service that perfectly aligned with our business goals.",
        fullName: "Laura García",
        country: "Colombia",
        companyName: "Papeles y Colores LTDA",
        industry: "E-commerce",
        comment: "The service was top-notch, perfectly aligning with our business goals. The expert advice and leadership provided were crucial in navigating our technological landscape, making a significant positive impact.",
      },
      {
        stars: 9,
        service: "CTO as a Service",
        commentTitle: "Exceptional service that drove our technological innovation.",
        fullName: "Juan Pérez",
        country: "Colombia",
        companyName: "Ingenieria JP SAS",
        industry: "Construction",
        comment: "The service was exceptional, driving our technological innovation. Their strategic insights and expert guidance were key to our success, seamlessly integrating with our team and pushing us forward.",
      },
      {
        stars: 10,
        service: "Custom Development",
        commentTitle: "Innovative development solutions that exceeded our expectations.",
        fullName: "María Rodríguez",
        country: "Colombia",
        companyName: "Desarrollos Creativos LTDA",
        industry: "Small Retail",
        comment: "The custom development solutions provided were innovative and exceeded our expectations. Their ability to handle complex technical challenges was impressive, resulting in successful project outcomes.",
      },
      {
        stars: 10,
        service: "CTO as a Service",
        commentTitle: "Highly beneficial service with minor areas for improvement.",
        fullName: "Carlos Martínez",
        country: "Spain",
        companyName: "Soluciones Empresariales SL",
        industry: "Lawyer Firm",
        comment: "The service was highly beneficial and provided significant strategic value. While the overall experience was positive, there were a few areas where more frequent interaction could have enhanced the outcome.",
      },
      {
        stars: 10,
        service: "CTO as a Service",
        commentTitle: "Exceptional strategic leadership that drove our success.",
        fullName: "Ana García",
        country: "Spain",
        companyName: "Repuestos Online SL",
        industry: "E-commerce",
        comment: "Their exceptional strategic leadership was crucial in driving our success. The expertise and insights provided were invaluable, seamlessly aligning with our business goals and facilitating significant growth.",
      },
      {
        stars: 9,
        service: "CTO as a Service",
        commentTitle: "Outstanding service that boosted our technological capabilities.",
        fullName: "Luis Hernández",
        country: "Spain",
        companyName: "Tecnologías Avanzadas SL",
        industry: "Construction",
        comment: "The service was outstanding, significantly boosting our technological capabilities. Their strategic guidance and expert support were instrumental in our growth, providing exceptional value throughout the engagement.",
      },
      {
        stars: 7,
        service: "CTO as a Service",
        commentTitle: "Transformative service that perfectly aligned with our vision.",
        fullName: "María Sánchez",
        country: "Spain",
        companyName: "OffiTech SA",
        industry: "Small Retail",
        comment: "The service was transformative, perfectly aligning with our vision and driving substantial progress. Their strategic insights and seamless integration with our team were key to our success, making a significant impact on our technological landscape.",
      },
    ]);

    const model = ref(null);

    const shuffleArray = (array) => {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };

    const shuffledReviews = computed(() => {
      return shuffleArray([...customerReviews.value]);
    });

    const getCountryCode = (countryName) => {
      const countryCodes = {
        "United States": "us",
        Mexico: "mx",
        Bulgaria: "bg",
        Chile: "cl",
        Finland: "fi",
        Colombia: "co",
        Spain: "es",
      };
      return countryCodes[countryName] || "unknown";
    };

    return {
      shuffledReviews,
      model,
      getCountryCode,
    };
  },
};
</script>

<style scoped>
.review-sheet {
  border-radius: 25px;
  background: transparent !important;
}

.review-card {
  background: transparent !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 25px !important;
}

.clean-icon {
  background-color: transparent !important;
  box-shadow: none !important;
  margin: 0;
  padding: 0;
}

.mobile-reviews {
  max-height: 80vh;
  overflow-y: auto;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
}

.mobile-reviews .v-card {
  max-width: 100%;
  padding: 8px;
  margin: 8px 0;
  flex: 0 0 auto;
}

.mobile-rating .v-rating {
  font-size: 0.8rem;
  display: flex;
  align-items: center;
}

.mobile-rating .v-rating .v-rating__item {
  margin-right: 2px !important;
}
</style>
